import React from "react";
import PropTypes from "prop-types";

const PractitionerLocationTitle = ({ data }) => {
    const identifiers = data?.practitioner?.identifiers || [];
    const providerNpi = identifiers
        .filter(x => x?.identifierType?.code === "NPI")
        .map(y => y?.value)
        .filter(Boolean)
        .sort()
        .join(", ");

    const loc = data?.location;
    const street = [loc?.addressLine1, loc?.addressLine2].filter(Boolean).join(" ");
    const cityStateZip = [
        loc?.city ? `${loc.city},` : "",
        loc?.state,
        loc?.postalCode
    ].filter(Boolean).join(" ");

    const fullAddress = [street, cityStateZip].filter(Boolean).join(" ");
    const providerAddress = fullAddress ? `(${fullAddress})` : "";

    const displayName = data?.practitioner?.applicableVersion?.displayName;
    const locationName = data?.location?.applicableVersion?.name;
    const serviceName = data?.legalContractLineOfService?.lineOfService?.name;

    return (
        <>
            {displayName}
            {providerNpi && (
                <>
                    <small> (NPI {providerNpi})</small><br />
                </>
            )}
            {locationName && ` at ${locationName}`}
            {providerAddress && <small> {providerAddress}</small>}
            {serviceName && `, ${serviceName}`}
        </>
    );
};

PractitionerLocationTitle.propTypes = {
    data: PropTypes.shape({})
}
export default PractitionerLocationTitle;